export const setName = data => ({
  type: 'SET_NAME',
  data,
});
